import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12">
          关于91免费看片平台，你想知道的都在这里
        </p>
        <div className="space-y-4">
          {faqItems.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-lg p-5 md:p-6">
              <h3 className="text-base font-semibold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="text-primary-500 font-bold text-lg shrink-0">Q{i + 1}</span>
                <span>{item.question}</span>
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-8">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}